import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { StarIcon, ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
const reviews = [{
  id: 1,
  name: 'Sarah K.',
  role: 'Content Creator',
  text: "Finally, a lamp that I can stick to my window for reading. It's genius and looks amazing on my setup!",
  image: 'https://cdn.magicpatterns.com/uploads/gxK9FhSEDowV626yk5TdsP/61J5pIRK-7L.jpg'
}, {
  id: 2,
  name: 'Mark T.',
  role: 'Parent',
  text: 'My kids used to be afraid of the dark. Now they have their Light Man stuck to their bedposts. Durable and fun.',
  image: 'https://cdn.magicpatterns.com/uploads/mgjzJDViwYTN4NGXT5NUX4/81EQM2B1Zy6L.jpg'
}, {
  id: 3,
  name: 'Daniel R.',
  role: 'Software Engineer',
  text: 'The ultimate conversation starter for Zoom calls. Everyone asks where I got it.',
  image: 'https://cdn.magicpatterns.com/uploads/t3acGdCTtAQvVU8pYpWvER/creative_43fea84(768x1344)_(1).jpg'
}, {
  id: 4,
  name: 'Jessica L.',
  role: 'Graphic Designer',
  text: 'I bought four for my studio. They stick everywhere and the warm light is perfect for late-night creative sessions.',
  image: 'https://cdn.magicpatterns.com/uploads/gHEmjL8dTveGgYYeuPW5QD/IMG_1140.jpg'
}, {
  id: 5,
  name: 'Ryan M.',
  role: 'College Student',
  text: 'Best purchase I made all semester. Sticks right to my dorm desk and the battery lasts forever.',
  image: 'https://cdn.magicpatterns.com/uploads/nxBBuY89Lqi6RHZA8zebLR/6A111800-604C-4298-857F-B2C5DDF34F15.png'
}];
export function ReviewCarousel() {
  const [currentIndex, setCurrentIndex] = useState(0);
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentIndex(prev => (prev + 1) % reviews.length);
    }, 4000);
    return () => clearInterval(timer);
  }, []);
  const next = () => setCurrentIndex(prev => (prev + 1) % reviews.length);
  const prev = () => setCurrentIndex(prev => (prev - 1 + reviews.length) % reviews.length);
  return <section className="py-12 overflow-hidden" data-id="element-136">
      <h2 className="text-3xl font-bold text-center text-white mb-10" data-id="element-137">
        What Our Customers Say
      </h2>

      <div className="relative max-w-lg mx-auto px-4" data-id="element-138">
        <div className="relative h-[420px] sm:h-[380px]" data-id="element-139">
          <AnimatePresence mode="wait" data-id="element-140">
            <motion.div key={currentIndex} initial={{
            opacity: 0,
            x: 50
          }} animate={{
            opacity: 1,
            x: 0
          }} exit={{
            opacity: 0,
            x: -50
          }} transition={{
            duration: 0.3
          }} className="absolute inset-0 bg-brand-card border border-white/5 rounded-2xl overflow-hidden flex flex-col" data-id="element-141">
              <div className="w-full h-48 overflow-hidden" data-id="element-142">
                <img src={reviews[currentIndex].image} alt={`LumiMate review by ${reviews[currentIndex].name}`} className="w-full h-full object-cover" data-id="element-143" />
              </div>
              <div className="p-6 flex flex-col justify-center flex-1" data-id="element-144">
                <div className="flex gap-1 mb-3 text-brand-gold" data-id="element-145">
                  {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-5 h-5 fill-current" data-id="element-146" />)}
                </div>
                <p className="text-base text-white italic mb-4" data-id="element-147">
                  "{reviews[currentIndex].text}"
                </p>
                <div data-id="element-148">
                  <p className="font-bold text-brand-orange" data-id="element-149">
                    {reviews[currentIndex].name}
                  </p>
                </div>
              </div>
            </motion.div>
          </AnimatePresence>
        </div>

        <div className="flex justify-center gap-4 mt-6" data-id="element-150">
          <button onClick={prev} className="p-2 rounded-full bg-brand-card border border-white/10 text-white hover:bg-white/10 transition-colors" data-id="element-151">
            <ChevronLeftIcon className="w-6 h-6" data-id="element-152" />
          </button>
          <button onClick={next} className="p-2 rounded-full bg-brand-card border border-white/10 text-white hover:bg-white/10 transition-colors" data-id="element-153">
            <ChevronRightIcon className="w-6 h-6" data-id="element-154" />
          </button>
        </div>
      </div>
    </section>;
}